import PropTypes from 'prop-types';
import ODropDownMenu from '../../../../../UI/DropDownMenu/ODropDownMenu';
import { useTranslation } from 'react-i18next';

const GridOptions = ({ children, handleOpenDialog, getEditData }) => {
  const { t, i18n } = useTranslation();
  const options = [
    {
      title: t('edit'),
      subtitle: t('edit'),
      path: 'profil',
      id: 1,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      onClick: () => getEditData(),
    },
    {
      title: t('buttons.delete'),
      subtitle: t('buttons.delete'),
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDialog(),
    },
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  getEditData: PropTypes.func.isRequired,
};

export default GridOptions;
